import type { DateTime } from 'luxon';
import { useMemo, type ReactNode } from 'react';
import type { PrintableEvent } from '../../types';
import { DocumentContext } from './DocumentContext';

type Props = {
  isPrintEnv: boolean;
  targetDocument?: Document;
  onEventClick?: (event: PrintableEvent, instanceStart?: DateTime) => void;
  onCreateClick?: () => void;
  readOnly?: boolean;
  children: ReactNode;
};

export const DocumentContextProvider = ({
  isPrintEnv,
  targetDocument,
  onEventClick,
  onCreateClick,
  readOnly,
  children,
}: Props) => {
  const value = useMemo(
    () => ({
      isPrintEnv,
      targetDocument,
      onEventClick,
      onCreateClick,
      readOnly,
    }),
    [isPrintEnv, targetDocument, onEventClick, onCreateClick, readOnly]
  );

  return (
    <DocumentContext.Provider value={value}>
      {children}
    </DocumentContext.Provider>
  );
};
